@if (!isEmbedded()) {
  <lib-stage-bar></lib-stage-bar>
}

<!-- Auch eingebettet: dass gerade nichts ankommt, muss die Patient:in sehen, bevor sie ein
     Formular abschickt. Der Streifen rendert nichts, solange die Verbindung steht. -->
<lib-connection-banner></lib-connection-banner>

<router-outlet></router-outlet>
